import { useForm } from 'react-hook-form';
import { FormProvider, SelectTag, Table, TextField } from '../../../../../components';
import {
  Button,
  Container,
  Dialog,
  Divider,
  Grid,
  IconButton,
  Paper,
  Stack,
  Typography,
  TextField as MuiTextField,
  Box
} from '@mui/material';
import {  useEffect, useRef, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import {  dateFormatter, formatDate, getCurrentDateTime, getKeyPathValue, request, toast } from '../../../../../utils';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import { useLocation } from 'react-router-dom';
import { CustomButtonn } from '../../../../../components';
import { FamilyHistoryDetailsForm } from './FamilyHistoryDetailsForm';
import { IVFTreatementPatientHistory } from '../DetailsForms/IvfTreatementPatientHistory';
import { MenustralHistory } from '../DetailsForms/MenustralHistory';
import { InfertilityDetailsForm } from '../DetailsForms/InfertilityDetailsForm';
import { ObstericDetailsForm } from '../DetailsForms/ObstericDetailsForm';
import { MedicalHistory } from '../DetailsForms/MedicalHistory';
import { InfertilityTreatement } from '../DetailsForms/InfertilityTreatement';
import { PersonalHistoryDetailsForm } from '../DetailsForms/PerosonalHistoryDetailForm';
import { SurgicalHistoryDetailsForm } from '../DetailsForms/SurgicalHistoryDetailForm';
import { OvulationHistoryDetailsForm } from '../DetailsForms/OvulationHistoryDetailsForm';

const PATIENT_TABLE_HEADER = [
  { header: 'UHID',   accessor: (row) => {
    const status = row.status;
    return (
      <span
        style={{
          color: status === 'inactive' ? 'red' : 'black',
        }}
      >
        {`${row.uhid}`}
      </span>
    );
  },
},
  { header: 'OP No', accessor: 'op_no' },
  { header: 'Created At', accessor: 'createdAt' },
  { header: 'Patient Name', accessor: (row) => `${row.name_suffix} ${row.first_name} ${row.last_name}` },
  { header: 'Mobile No', accessor: 'address.mobile' },
  { header: 'Doctor', accessor: 'consultant.name' },
  { header: 'Department', accessor: 'department.department' },
  { header: 'Address', accessor: 'address.address' }
];

const TABLE_HEADER = [
  {
    header: ' Date',
    accessor: (row) => `${getCurrentDateTime('date', row.createdAt)}`
  },
  {
    header: 'UHID No',
    accessor: 'uhid'
  },
  {
    header: 'Patient Name',
    accessor: (row) => {
      const status = row.status;
      return (
        <span
          style={{
            color: status === 'inactive' ? 'red' : 'black'
          }}
        >
          {`${row?.patient?.name_suffix} ${row?.patient?.first_name} ${row?.patient?.last_name}`}
        </span>
      );
    }
  },
  {
    header: 'Sponsor',
    accessor: (row) => row?.patient?.sponsor?.name
  },
  {
    header: 'Mobile No',
    accessor: (row) => row?.patient?.address?.mobile
  }
];

const PATIENT_HISTORY_DETAIL_HEADER = [
  {
    header: 'Married Year',
    accessor: 'married_year'
  },
  {
    header: 'Marriage No',
    accessor: 'marriage_no'
  },
  {
    header: 'Previous Delivery',
    accessor: 'previous_delivery'
  },
  {
    header: 'Delivery Details',
    accessor: 'delivery_type'
  }
];

const INFERTILITY_DETAIL_HEADER = [
  {
    header: 'Primary Infertility',
    accessor: 'primary_infertility'
  },
  {
    header: 'Secondary Infertility',
    accessor: 'secondary_infertility'
  },
  {
    header: 'Abortion',
    accessor: 'abortion'
  },
  {
    header: 'DNC',
    accessor: 'dnc'
  },
  {
    header: 'Doctor Name',
    accessor: 'doctor'
  },
  {
    header: 'MTP',
    accessor: 'mtp'
  },
  {
    header: 'MTP By Doctor',
    accessor: 'mtp_by_doctor'
  },
  {
    header: 'IUD',
    accessor: 'iud'
  },
  {
    header: 'NND',
    accessor: 'nnd'
  },
  {
    header: 'Other',
    accessor: 'other'
  }
];

const OBSTERIC_DETAIL_HEADER = [
  {
    header: 'G',
    accessor: 'g'
  },
  {
    header: 'P',
    accessor: 'p'
  },
  {
    header: 'L',
    accessor: 'l'
  },
  {
    header: 'MTP',
    accessor: 'mtp'
  }
];

const MEDICAL_HISTORY_DETAIL_HEADER = [
  {
    header: 'TB',
    accessor: 'tb'
  },
  {
    header: 'Rx For TB',
    accessor: 'tb_fix'
  },
  {
    header: 'DM',
    accessor: 'dm'
  },
  {
    header: 'DM Years',
    accessor: 'dm_years'
  },
  {
    header: 'Rx For Dm',
    accessor: 'dm_fix'
  }
];

const INFERTILITY_TREATEMENT_DETAIL_HEADER = [
  {
    header: 'Laproscopy',
    accessor: 'laproscopy'
  },
  {
    header: 'Hystroscopic',
    accessor: 'hystroscopic'
  },
  {
    header: 'HSG',
    accessor: 'hsg'
  },
  {
    header: 'Medical Treatement',
    accessor: 'medical_treatement'
  },
  {
    header: 'IVF/CSI',
    accessor: 'ivf_csi'
  }
];

const PERSONAL_HISTORY_DETAIL_HEADER = [
  {
    header: 'Breast Discharge',
    accessor: 'breast_discharge'
  },
  {
    header: 'Breast Side',
    accessor: 'breast_side'
  },
  {
    header: 'Hirsutism',
    accessor: 'hirustism'
  },
  {
    header: 'White Discharge',
    accessor: 'white_discharge'
  },
  {
    header: 'Discharge Type',
    accessor: 'discharge_type'
  },
];

const FAMILY_HISTORY_DETAIL_HEADER = [
  {
    header: 'Disease',
    accessor: 'disease'
  },
  {
    header: 'Relation',
    accessor: 'relation'
  },
  {
    header: 'Description',
    accessor: 'description'
  }
];

const MENUSTRAL_CYCLE_DETAIL = [
  {
    header: 'Previous',
    accessor: 'previous_cycle'
  },
  {
    header: 'Prev. Cycle Type',
    accessor: 'previous_cycle_type'
  },
  {
    header: 'Present Cycle',
    accessor: 'present_cycle'
  },
  {
    header: 'Present Cycle Type',
    accessor: 'present_cycle_type'
  },
  {
    header: 'Days',
    accessor: 'days'
  },
  {
    header: 'Last Menustral Date',
    accessor:(row)=> formatDate(row?.last_menustral_date)
  },
  {
    header: 'Details',
    accessor: 'details'
  },
  {
    header: 'Dysmenorrhea',
    accessor: 'dysmenorrhea'
  }
];


const SURGICAL_HISTORY_DETAIL_HEADER = [
  {
    header: 'Surgery',
    accessor: (row) => row?.surgery
  },
  {
    header: 'Laparoscopy',
    accessor: 'laparoscopy'
  },
  {
    header: 'Laparoscopy Date',
    accessor:(row)=> formatDate(row?.laparoscopy_date)
  },
  {
    header: 'Laparo. By Doctor',
    accessor: 'laparoscopy_by_doctor'
  },
  {
    header: 'Utreus',
    accessor: 'uterus'
  },
  {
    header: 'Adhension',
    accessor: 'adhension'
  },
  {
    header: 'Fibroid',
    accessor: 'fibroid'
  },
  {
    header: 'Hystroscopy',
    accessor: 'hystroscopy'
  },
  {
    header: 'Laparoscopy Date',
    accessor:(row)=> formatDate(row?.hystroscopy_date)
  },
  {
    header: 'Hystro. By Doctor',
    accessor: 'hystroscopy_by_doctor'
  },

];


const OVULATION_STUDY_DETAIL = [
  {
    header: 'Date',
    accessor: 'date'
  },
  {
    header: 'Indication',
    accessor: 'indication'
  },
  {
    header: 'Down Regulation',
    accessor: 'down_regulation'
  },
  {
    header: 'Day',
    accessor: 'day'
  },
  {
    header: 'Injecction',
    accessor: 'injection'
  },
  {
    header: 'Tablet',
    accessor: 'tablet'
  },
];

const initialPatientDataObj = {
  data: [],
  loading: false
};

export const IVFTreatement = () => {
  const doctorIDRef = useRef();
  const sponsorIDRef = useRef();
  const { pathname } = useLocation();
  const lastPathSegment = pathname.split('/').pop();
  const [loading, setLoading] = useState(false);
  const [currentAction, setCurrentAction] = useState();
  const [selectedRecord, setSelectedRecord] = useState();
  const [patientDataObj, setPatientDataObj] = useState(initialPatientDataObj);
  const [openQueryDialog, setOpenQueryDialog] = useState(false);
  const [searchPatientRegisterationDialog, setSearchPatientRegisterationDialog] = useState(false);
  const [patientDetailList, setPatientDetailList] = useState([]);
  const [activeTab, setActiveTab] = useState(0);
  const [familyHistory, setFamilyHistory] = useState([]);
  const [familyHistoryDialogueOpen, setFamilyHistoryDialogueOpen] = useState(false);
  const [queryInput, setQueryInput] = useState('');
  const [patientHistoryDialog, setPatientHistoryDialog] = useState(false);
  const [patientHistory, setPatientHistory] = useState([]);
  const [menustralHistoryDialog, setMenustralHistoryDialog] = useState(false);
  const [menustralHistory, setMenustralHistory] = useState([]);
  const [infertilityDialog, setInfertilityDialog] = useState(false);
  const [infertility, setInfertility] = useState([]);
  const [obstericHistoryDialog, setObstericHistoryDialog] = useState(false);
  const [obsteric, setObsteric] = useState([]);
  const [medicalHistory, setMedicalHistory] = useState([]);
  const [medicalHistoryDialog, setMedicalHistoryDialog] = useState(false);
  const [infertilityTreatment, setInfertilityTreatment] = useState([]);
  const [infertilityTreatmentDialog, setInfertilityTreatmentDialog] = useState(false);
  const [personalHistoryDialog,setPersonalHistoryDialog] = useState(false)
  const [personalHistory,setPerosnalHistory] = useState([])
  const [surgicalHistoryDialog,setSurgicalHistoryDialog] = useState(false)
  const [surgicalHistory,setSurgicalHistory] = useState([])
  const [ovulationStudy,setOvulationStudy] = useState([])
  const[ovulationStudyDialog,setOvulationStudyDialog] = useState(false)


  const calculateAge = (dob) => {
    const birthDate = new Date(dob);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDifference = today.getMonth() - birthDate.getMonth();
    const dayDifference = today.getDate() - birthDate.getDate();
    if (monthDifference < 0 || (monthDifference === 0 && dayDifference < 0)) {
      age--;
    }
    return age;
  };

  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        uhid: Yup.string().required(' ')
      })
    ),
    defaultValues: {
      date: new Date().toISOString().split('T')[0],
      time: getCurrentDateTime('time')
    },
    mode: 'all'
  });
  const { handleSubmit, watch, reset, setValue } = methods;


  useEffect(() => {
    if (selectedRecord) {
      const keyValuePair = getKeyPathValue(selectedRecord, 'bill', [
        '__v',
        '_id',
        'createdAt',
        'status',
        'service_items',
        'uhid',
        'complaints',
        'diagnos',
        'medicine',
        'vital'
      ]);
      keyValuePair.forEach(({ key, value }) => setValue(key, value));
      setValue('uhid', selectedRecord.uhid);
      setValue(
        'patient_name',
        `${selectedRecord.patient?.name_suffix} ${selectedRecord.patient?.first_name} ${selectedRecord.patient?.last_name}`
      );
      const formattedRegDate = selectedRecord?.date ? new Date(selectedRecord.date).toISOString().split('T')[0] : '';
      setValue('date', formattedRegDate);
      setValue('patient_age', calculateAge(selectedRecord?.patient?.dob));
      setValue('mobile', selectedRecord?.patient?.address?.mobile);
      setValue('doctor', selectedRecord?.patient?.consultant?.name);
      setValue('department', selectedRecord?.patient?.department?.department);
      sponsorIDRef.current = selectedRecord?.patient?.sponsor?._id;
      setPatientHistory(selectedRecord.patient_history);
      setMenustralHistory(selectedRecord.menustral_history);
      setInfertility(selectedRecord?.infertility_details);
      setObsteric(selectedRecord?.obsteric_details);
      setMedicalHistory(selectedRecord?.medical_history);
      setInfertilityTreatment(selectedRecord?.infertility_treatement);
      setPerosnalHistory(selectedRecord?.personal_history);
      setFamilyHistory(selectedRecord?.family_history);
      setSurgicalHistory(selectedRecord?.surgical_history);
      setOvulationStudy(selectedRecord?.ovulation_study)

    } else {
      reset();
    }
  }, [selectedRecord]);

  const formSubmit = async (formValues) => {
    setLoading(true);
    let editFlag = false;
    if (selectedRecord && currentAction === 'edit') {
      editFlag = true;
    }
    const response = await request(editFlag ? '/ivf-treatement-update' : '/ivf-treatement-create', {
      method: editFlag ? 'PUT' : 'POST',
      params: editFlag ? selectedRecord._id : null,
      body: {
        ...formValues,
        patient_history: patientHistory,
        menustral_history: menustralHistory,
        infertility_details: infertility,
        obsteric_details: obsteric,
        medical_history: medicalHistory,
        infertility_treatement: infertilityTreatment,
        personal_history: personalHistory,
        surgical_history:surgicalHistory,
        family_history: familyHistory,
        ovulation_study:ovulationStudy,
      }
    });
    if (response?.success) {
      toast(`Successfully ${editFlag ? 'updated' : 'created'} IVF Treatement`, { variant: 'success' });
      setSelectedRecord(response.data);
      setCurrentAction();
      reset();
    } else {
      toast(`Failed to ${editFlag ? 'update' : 'create'} IVF Treatement`, {
        variant: 'error'
      });
    }
    setLoading(false);
  };

  const handlePatientHistoryDelete = (rowId) => {
    setPatientHistory((prev) =>
      prev.filter((data,index) => {
        return index != rowId;
      })
    );
  };

  const handleMenustalDelete = (rowId) => {
    setMenustralHistory((prev) =>
      prev.filter((data,index) => {
        return index != rowId;
      })
    );
  };

  const handleDeletePersonalHistory = (rowId) => {
    setPerosnalHistory((prev) =>
      prev.filter((data,index) => {
        return index != rowId;
      })
    );
  };

  const handleDeleteInfertility = (rowId) => {
    setInfertility((prev) =>
      prev.filter((data,index) => {
        return index != rowId;
      })
    );
  };


  const handleDeleteObsteric = (rowId) => {
    setObsteric((prev) =>
      prev.filter((data,index) => {
        return index != rowId;
      })
    );
  };

  const handleDeleMedicalHistory= (rowId) => {
    setMedicalHistory((prev) =>
      prev.filter((data,index) => {
        return index != rowId;
      })
    );
  };

  const handleDeleteSurgicalHistory= (rowId) => {
    setSurgicalHistory((prev) =>
      prev.filter((data,index) => {
        return index != rowId;
      })
    );
  };

  const handleDeleteInfertilityTreatement = (rowId) => {
    setInfertilityTreatment((prev) =>
      prev.filter((data,index) => {
        return index != rowId;
      })
    );
  };

  const handleDeleteFamilyHistory = (rowId) => {
    setFamilyHistory((prev) =>
      prev.filter((data,index) => {
        return index != rowId;
      })
    );
  };

  const handleDeleteOvulationStudy = (rowId) => {
    setOvulationStudy((prev) =>
      prev.filter((data,index) => {
        return index != rowId;
      })
    );
  };


  const handleDeleteRecord = async () => {
    setLoading(true);
    const response = await request('/ivf-treatement-delete', {
      method: 'DELETE',
      params: selectedRecord._id
    });
    if (response?.success) {
      toast('Successfully deleted IVF Treatement', { variant: 'success' });
      setSelectedRecord();
    } else {
      toast('Failed to delete IVF Treatement', { variant: 'error' });
    }
    setLoading(false);
  };

  const handleCancelRecord = async () => {
    setLoading(true);
    const response = await request('/ivf-treatement-cancel', {
      method: 'DELETE',
      params: selectedRecord._id
    });
    if (response?.success) {
      toast('Successfully cancel IVF Treatement', { variant: 'success' });
      setSelectedRecord();
    } else {
      toast('Failed to cancel IVF Treatement', { variant: 'error' });
    }
    setLoading(false);
  };

  const handleQueryWindow = async () => {
    setOpenQueryDialog(true);
    setPatientDataObj({ loading: true });
    const response = await request('/ivf-treatement-all', { method: 'GET' });
    if (response.success) {
      const filteredData = response.data.filter(item => item.status === 'active' || item.status === 'inactive');
      setPatientDataObj({ loading: false, data: filteredData });
    } else {
      toast('Error in fetching data', { variant: 'error' });
      setPatientDataObj({ loading: false });
    }
  };
  

  const searchPatientHandler = async (uhid = null) => {
    if (typeof uhid !== 'number' && typeof uhid !== 'string') uhid = null;
    setLoading(true);
    const today = new Date().toISOString().split('T')[0];
    if (!uhid) setSearchPatientRegisterationDialog(true);
    const response = await request('/patient-registeration-gynae-list', {
      method: 'GET',
      query: { uhid }
    });
    if (response?.success) {
      if (uhid) {
        const {
          data: [patientData]
        } = response;
        setValue('visit_no', patientData.visit_no);
        setValue('op', patientData.op_no);
        setValue('patient_name', `${patientData.first_name} ${patientData.last_name}`);
        setValue('patient_suffix', patientData.name_suffix);
        setValue('opd_type', patientData.opd_type?.type);
        setValue('ref_type', patientData.ref_by?.referral_name);
        setValue('application_no', patientData.app_no_date);
        setValue('doctor', patientData.consultant?.name);
        doctorIDRef.current = patientData.consultant?._id;
        setValue('department', patientData.department?.department);
        setValue('patient_age', calculateAge(patientData?.dob));
        setValue('sponsor', patientData.sponsor?.name);
        setValue('remarks', patientData.remarks);
        setValue('queue_no', patientData.app_no_date);
        setValue('card_no', patientData.chq_card_no);
        setValue('vertical', patientData.vertical?.verticalname);
      } else {
        setPatientDetailList(response.data);
      }
    } else {
      toast('Failed to load patient details', { variant: 'error' });
    }
    setLoading(false);
  };

  const handleActiveTab = (newTabIndex) => {
    setActiveTab(newTabIndex);
  };

  const onAddPatientHistory = (row) => {
    setPatientHistory((prev) => [
      ...prev,
      {
        married_year: row.married_year,
        marriage_no: row?.marriage_no,
        previous_delivery: row?.previous_delivery,
        delivery_type: row.delivery_type
      }
    ]);
  };

  const searchHistoryDetails = async (uhid) => {
    setLoading(true);
    const response = await request('/ivf-patient-history-detail', {
      method: 'GET',
      params: uhid
    });
    if (response?.success) {
      const { data } = response;
      if (!data) {
        toast('No patient found', { variant: 'warning' });
      } else {
      
      }
    } else {
      toast('Failed to load patient details', { variant: 'error' });
    }
    setLoading(false);
  };

  useEffect(() => {
    handleSearch(queryInput);
  }, [queryInput]);

  const handleSearch = async () => {
    const lowercasedInput = queryInput.toLowerCase().trim();
    try {
      const query = {};
      if (lowercasedInput) {
        query.name = lowercasedInput;
      }
      const response = await request('/ivf-treatement-all', {
        method: 'GET',
        query: query
      });
      if (response.success) {
        setPatientDataObj({ loading: false, data: response.data });
      } else {
        toast('Error in fetching data', { variant: 'error' });
        setPatientDataObj({ loading: false });
      }
    } catch (error) {
      console.error('Error during search:', error);
      toast('Error during search', { variant: 'error' });
      setPatientDataObj({ loading: false, data: [] });
    }
  };

  const handleQueryChange = (e) => {
    setQueryInput(e.target.value);
  };


  return (
    <>
      <Paper sx={{ p: 0, flex: 1, borderRadius: 0, boxShadow: 'none' }}>
        <Container
          sx={{
            mt: 1,
            border: '0px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            maxWidth: 'none',
            minWidth: '100%',
            boxSizing: 'border-box'
          }}
        >
          <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                mb: 1,
                borderBottom: '0px solid',
                borderColor: 'grey.300'
              }}
            >
              <Typography color="primary" variant="h3" sx={{ fontWeight: 700 }}>
                IVF Treatement
              </Typography>
              <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                <CustomButtonn
                  id={`${lastPathSegment}Write`}
                  variant="contained"
                  disabled={['edit', 'new'].includes(currentAction)}
                  onClick={() => {
                    setSelectedRecord();
                    setCurrentAction('new');
                    reset();
                  }}
                >
                  New
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Update`}
                  variant="contained"
                  disabled={['new', 'edit'].includes(currentAction) || !selectedRecord}
                  onClick={() => setCurrentAction('edit')}
                >
                  Edit
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Print`}
                  variant="contained"
                  onClick={() => window.open(`/print${pathname}?refId=${selectedRecord._id}`, '_blank')}
                  disabled={!selectedRecord || currentAction}
                >
                  Print
                </CustomButtonn>
                <CustomButtonn
                  id={'Submit'}
                  type="submit"
                  variant="contained"
                  disabled={!['edit', 'new'].includes(currentAction) || loading}
                >
                  Save
                </CustomButtonn>
                <CustomButtonn
                  id={'Cancel'}
                  variant="contained"
                  disabled={['edit', 'new'].includes(currentAction) || loading}
                  onClick={() => {
                    setCurrentAction();
                    handleCancelRecord();
                  }}
                >
                  Cancel
                </CustomButtonn>
                <CustomButtonn
                  id={`isSuperAdmin`}
                  variant="contained"
                  disabled={!selectedRecord || ['new', 'edit'].includes(currentAction) || loading}
                  onClick={handleDeleteRecord}
                >
                  Delete
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Read`}
                  variant="contained"
                  onClick={handleQueryWindow}
                  disabled={['new', 'edit'].includes(currentAction)}
                >
                  Query
                </CustomButtonn>
                <CustomButtonn
                  id={'Exit'}
                  variant="contained"
                  onClick={() => {
                    setCurrentAction('');
                  }}
                >
                  Exit
                </CustomButtonn>
              </Stack>
            </Stack>
            <Box
              sx={{
                border: '0px solid gray',
                padding: 2,
                borderRadius: '8px',
                width: '100%',
                boxShadow: '0px 2px 10px #0099ff'
              }}
            >
              <Grid container spacing={2}>
                <Grid
                  item
                  xs={4}
                  sx={{ display: 'flex', gap: 0.3, flexDirection: 'column', boxShadow: '0px 2px 2px #0099ff' }}
                >
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.2, fontWeight: 600, fontSize: '1.4rem' }}>Visit No</Typography>
                    <TextField sx={{ flex: 0.7 }} name="visit_no" disabled />
                    <Button
                      sx={{ flex: 0.1, minWidth: 0, p: 0.25, height: '100%' }}
                      variant="contained"
                      onClick={searchPatientHandler}
                      disabled={!['new', 'edit'].includes(currentAction)}
                    >
                      <SearchIcon />
                    </Button>
                  </Stack>
                  <Stack direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.21, fontWeight: 600, fontSize: '1.4rem' }}>Date</Typography>
                    <TextField sx={{ flex: 0.8 }} name="date" type="date" disabled />
                  </Stack>
                </Grid>
                <Grid
                  item
                  xs={4}
                  sx={{ display: 'flex', gap: 0.3, flexDirection: 'column', boxShadow: '0px 2px 2px #0099ff' }}
                >
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 600, fontSize: '1.4rem' }}>Doc No./Date</Typography>
                    <TextField disabled={true} sx={{ flex: 0.4 }} placeholder="Doc No." name="doc_no" />
                    <TextField disabled={true} sx={{ flex: 0.4 }} placeholder="Bill No." name="date" />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.2, fontWeight: 600, fontSize: '1.4rem' }}>Patient/Age</Typography>
                    <TextField disabled={true} name="patient_name" sx={{ flex: 0.4 }} placeholder="Patient Name" />
                    <TextField disabled={true} name="patient_age" sx={{ flex: 0.4 }} placeholder="Age" />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.2, fontWeight: 600, fontSize: '1.4rem' }}>Doctor</Typography>
                    <TextField disabled={true} sx={{ flex: 0.8 }} name="doctor" placeholder="Doctor" />
                  </Stack>
                </Grid>
                <Grid
                  item
                  xs={4}
                  sx={{ display: 'flex', gap: 0.3, flexDirection: 'column', boxShadow: '0px 2px 2px #0099ff' }}
                >
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 600, fontSize: '1.4rem' }}>UHID No</Typography>
                    <TextField sx={{ flex: 0.8 }} name="uhid" placeholder="Search By Uhid " disabled />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 600, fontSize: '1.4rem' }}>Op/Mobile No.</Typography>
                    <TextField disabled={true} sx={{ flex: 0.4 }} name="op" placeholder="Op No." />
                    <TextField disabled={true} sx={{ flex: 0.4 }} name="mobile" placeholder="Mobile No." />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 600, fontSize: '1.4rem' }}>Department</Typography>
                    <TextField disabled sx={{ flex: 0.8 }} name="department" placeholder="Department" />
                  </Stack>
                </Grid>
                <Grid item xs={12}>
                  <Box sx={{ borderBottom: '1px solid', borderColor: 'divider' }}>
                    <Button
                      variant="contained"
                      disabled={!['new', 'edit'].includes(currentAction)}
                      onClick={() => handleActiveTab(0)}
                      sx={{
                        my: 0,
                        mx: 1,
                        borderRadius: '4px',
                        fontWeight: 800,
                        backgroundColor: activeTab === 0 ? 'primary.main' : 'default',
                        color: activeTab === 0 ? 'white' : 'text.primary'
                      }}
                    >
                      History
                    </Button>
                    <Button
                      variant="contained"
                      disabled={!['new', 'edit'].includes(currentAction)}
                      onClick={() => handleActiveTab(1)}
                      sx={{
                        my: 0,
                        mx: 1,
                        borderRadius: '4px',
                        fontWeight: 800,
                        backgroundColor: activeTab === 1 ? 'primary.main' : 'default',
                        color: activeTab === 1 ? 'white' : 'text.primary'
                      }}
                    >
                      Menustral History
                    </Button>
                    <Button
                      variant="contained"
                      disabled={!['new', 'edit'].includes(currentAction)}
                      onClick={() => handleActiveTab(2)}
                      sx={{
                        my: 0,
                        mx: 1,
                        borderRadius: '4px',
                        fontWeight: 800,
                        backgroundColor: activeTab === 2 ? 'primary.main' : 'default',
                        color: activeTab === 2 ? 'white' : 'text.primary'
                      }}
                    >
                      Personal History
                    </Button>
                    <Button
                      variant="contained"
                      onClick={() => handleActiveTab(3)}
                      disabled={!['new', 'edit'].includes(currentAction)}
                      sx={{
                        my: 0,
                        mx: 1,
                        borderRadius: '4px',
                        fontWeight: 800,
                        backgroundColor: activeTab === 3 ? 'primary.main' : 'default',
                        color: activeTab === 3 ? 'white' : 'text.primary'
                      }}
                    >
                      Infertility
                    </Button>
                    <Button
                      variant="contained"
                      onClick={() => handleActiveTab(4)}
                      disabled={!['new', 'edit'].includes(currentAction)}
                      sx={{
                        backgroundColor: activeTab === 4 ? 'primary.main' : 'default',
                        color: activeTab === 4 ? 'white' : 'text.primary',
                        my: 0,
                        mx: 1,
                        borderRadius: '4px',
                        fontWeight: 800
                      }}
                    >
                      Obesteric History
                    </Button>
                    <Button
                      variant="contained"
                      disabled={!['new', 'edit'].includes(currentAction)}
                      onClick={() => handleActiveTab(5)}
                      sx={{
                        my: 0,
                        mx: 1,
                        borderRadius: '4px',
                        fontWeight: 800,
                        backgroundColor: activeTab === 5 ? 'primary.main' : 'default',
                        color: activeTab === 5 ? 'white' : 'text.primary'
                      }}
                    >
                      Medical History
                    </Button>
                    <Button
                      variant="contained"
                      onClick={() => handleActiveTab(6)}
                      disabled={!['new', 'edit'].includes(currentAction)}
                      sx={{
                        my: 0,
                        mx: 1,
                        borderRadius: '4px',
                        fontWeight: 800,
                        backgroundColor: activeTab === 6 ? 'primary.main' : 'default',
                        color: activeTab === 6 ? 'white' : 'text.primary'
                      }}
                    >
                      Surgical History
                    </Button>
                    <Button
                      variant="contained"
                      onClick={() => handleActiveTab(7)}
                      disabled={!['new', 'edit'].includes(currentAction)}
                      sx={{
                        my: 0,
                        mx: 1,
                        borderRadius: '4px',
                        fontWeight: 800,
                        backgroundColor: activeTab === 7 ? 'primary.main' : 'default',
                        color: activeTab === 7 ? 'white' : 'text.primary'
                      }}
                    >
                      Infertility Treatement
                    </Button>
                    <Button
                      variant="contained"
                      onClick={() => handleActiveTab(8)}
                      disabled={!['new', 'edit'].includes(currentAction)}
                      sx={{
                        my: 0,
                        mx: 1,
                        borderRadius: '4px',
                        fontWeight: 800,
                        backgroundColor: activeTab === 8 ? 'primary.main' : 'default',
                        color: activeTab === 8 ? 'white' : 'text.primary'
                      }}
                    >
                      Family History
                    </Button>
                    <Button
                      variant="contained"
                      onClick={() => handleActiveTab(9)}
                      disabled={!['new', 'edit'].includes(currentAction)}
                      sx={{
                        my: 0,
                        mx: 1,
                        borderRadius: '4px',
                        fontWeight: 800,
                        backgroundColor: activeTab === 9 ? 'primary.main' : 'default',
                        color: activeTab === 9 ? 'white' : 'text.primary'
                      }}
                    >
                      Ovulation Study
                    </Button>
                  </Box>
                  {activeTab === 0 && (
                    <>
                      <Button
                        sx={{ marginTop: '1%', marginBottom: '0.5%' }}
                        variant="contained"
                        disabled={!['new', 'edit'].includes(currentAction)}
                        onClick={() => setPatientHistoryDialog(true)}
                      >
                        Add New
                      </Button>
                      <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'column' }}>
                        <Table
                          containerSX={{ flex: 1, border: '1px solid rgba(0,0,0,0.27)' }}
                          columns={PATIENT_HISTORY_DETAIL_HEADER}
                          data={patientHistory.map((data,index) => ({ _id: index, ...data })) || []}
                          showDeleteAction={true}
                          onDeleteHandler={handlePatientHistoryDelete}
                          disabled={!['new', 'edit'].includes(currentAction)}
                        />
                      </Grid>
                    </>
                  )}
                  {activeTab === 1 && (
                    <>
                      <Button
                        sx={{ marginTop: '1%', marginBottom: '0.5%' }}
                        variant="contained"
                        disabled={!['new', 'edit'].includes(currentAction)}
                        onClick={() => setMenustralHistoryDialog(true)}
                      >
                        Add New
                      </Button>
                      <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'column' }}>
                        <Table
                          containerSX={{ flex: 1, border: '1px solid rgba(0,0,0,0.27)' }}
                          columns={MENUSTRAL_CYCLE_DETAIL}
                          data={menustralHistory.map((data,index) => ({ _id: index, ...data })) || []}
                          showDeleteAction={true}
                          onDeleteHandler={handleMenustalDelete}
                          disabled={!['new', 'edit'].includes(currentAction)}
                        />
                      </Grid>
                    </>
                  )}
                  {activeTab === 2 && (
                    <>
                      <Button
                        sx={{ marginTop: '1%', marginBottom: '0.5%' }}
                        variant="contained"
                        disabled={!['new', 'edit'].includes(currentAction)}
                        onClick={() => setPersonalHistoryDialog(true)}
                      >
                        Add New
                      </Button>
                      <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                        <Table
                          containerSX={{ flex: 1, border: '1px solid rgba(0,0,0,0.27)' }}
                          columns={PERSONAL_HISTORY_DETAIL_HEADER}
                          data={personalHistory.map((data,index) => ({ _id: index, ...data }))}
                          showDeleteAction={true}
                          onDeleteHandler={handleDeletePersonalHistory}
                          disabled={!['new', 'edit'].includes(currentAction)}
                        />
                      </Grid>
                    </>
                  )}
                  {activeTab === 3 && (
                    <>
                      <Button
                        variant="contained"
                        sx={{ marginTop: '1%', marginBottom: '0.5%' }}
                        onClick={() => setInfertilityDialog(true)}
                        disabled={!['new', 'edit'].includes(currentAction)}
                      >
                        Add Details
                      </Button>
                      <Grid container spacing={2}>
                        <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                          <Table
                            containerSX={{ flex: 1, border: '1px solid rgba(0,0,0,0.27)' }}
                            columns={INFERTILITY_DETAIL_HEADER}
                            data={infertility.map((data,index) => ({ _id: index, ...data }))}
                            showDeleteAction={true}
                            onDeleteHandler={handleDeleteInfertility}
                            disabled={!['new', 'edit'].includes(currentAction)}
                          />
                        </Grid>
                      </Grid>
                    </>
                  )}
                  {activeTab === 4 && (
                    <>
                      <Button
                        variant="contained"
                        sx={{ marginTop: '1%', marginBottom: '0.5%' }}
                        onClick={() => setObstericHistoryDialog(true)}
                        disabled={!['new', 'edit'].includes(currentAction)}
                      >
                        Add Details
                      </Button>
                      <Grid container spacing={2}>
                        <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                          <Table
                            containerSX={{ flex: 1, border: '1px solid rgba(0,0,0,0.27)' }}
                            columns={OBSTERIC_DETAIL_HEADER}
                            data={obsteric.map((data,index) => ({ _id: index, ...data }))}
                            showDeleteAction={true}
                            onDeleteHandler={handleDeleteObsteric}
                            disabled={!['new', 'edit'].includes(currentAction)}
                          />
                        </Grid>
                      </Grid>
                    </>
                  )}

                  {activeTab === 5 && (
                    <>
                      <Button
                        variant="contained"
                        sx={{ marginTop: '1%', marginBottom: '0.5%' }}
                        onClick={() => setMedicalHistoryDialog(true)}
                        disabled={!['new', 'edit'].includes(currentAction)}
                      >
                        Add Details
                      </Button>
                      <Grid container spacing={2}>
                        <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                          <Table
                            containerSX={{ flex: 1, border: '1px solid rgba(0,0,0,0.27)' }}
                            columns={MEDICAL_HISTORY_DETAIL_HEADER}
                            data={medicalHistory?.map((data,index) => ({ _id: index, ...data })) || []}
                            showDeleteAction={true}
                            onDeleteHandler={handleDeleMedicalHistory}
                            disabled={!['new', 'edit'].includes(currentAction)}
                          />
                        </Grid>
                      </Grid>
                    </>
                  )}

                  {activeTab === 6 && (
                    <>
                      <Grid container spacing={2}>
                        <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'column', marginTop: '1%' }}>
                          <Button
                            variant="contained"
                            sx={{ width: '10%' ,marginBottom:0.8}}
                            onClick={() => setSurgicalHistoryDialog(true)}
                            disabled={!['new', 'edit'].includes(currentAction)}
                          >
                            Add Details
                          </Button>
                          <Table
                            containerSX={{ flex: 1, border: '1px solid rgba(0,0,0,0.27)' }}
                            columns={SURGICAL_HISTORY_DETAIL_HEADER}
                            data={surgicalHistory.map((data,index) => ({ _id: index, ...data }))}
                            showDeleteAction={true}
                            onDeleteHandler={handleDeleteSurgicalHistory}
                            disabled={!['new', 'edit'].includes(currentAction)}
                          />
                        </Grid>
                      </Grid>
                    </>
                  )}
                  {activeTab === 7 && (
                    <>
                      <>
                        <Grid container spacing={2}>
                          <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'column', marginTop: '1%' }}>
                            <Button
                              variant="contained"
                              sx={{ width: '10%', marginBottom: '0.5%' }}
                              onClick={() => setInfertilityTreatmentDialog(true)}
                              disabled={!['new', 'edit'].includes(currentAction)}
                            >
                              Add Details
                            </Button>
                            <Table
                              containerSX={{ flex: 1, border: '1px solid rgba(0,0,0,0.27)' }}
                              columns={INFERTILITY_TREATEMENT_DETAIL_HEADER}
                              data={infertilityTreatment.map((data,index) => ({ _id: index, ...data })) || []}
                              showDeleteAction={true}
                              onDeleteHandler={handleDeleteInfertilityTreatement}
                              disabled={!['new', 'edit'].includes(currentAction)}
                            />
                          </Grid>
                        </Grid>
                      </>
                    </>
                  )}

                  {activeTab === 8 && (
                    <>
                      <Button
                        variant="contained"
                        sx={{ marginTop: '1%', marginBottom: '0.5%' }}
                        onClick={() => setFamilyHistoryDialogueOpen(true)}
                        disabled={!['new', 'edit'].includes(currentAction)}
                      >
                        Add Details
                      </Button>
                      <Grid container spacing={2}>
                        <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                          <Table
                            containerSX={{ flex: 1, border: '1px solid rgba(0,0,0,0.27)' }}
                            columns={FAMILY_HISTORY_DETAIL_HEADER}
                            data={familyHistory.map((data,index) => ({ _id: index, ...data }))}
                            showDeleteAction={true}
                            onDeleteHandler={handleDeleteFamilyHistory}
                            disabled={!['new', 'edit'].includes(currentAction)}
                          />
                        </Grid>
                      </Grid>
                    </>
                  )}


                   {activeTab === 9 && (
                    <>
                      <Button
                        variant="contained"
                        sx={{ marginTop: '1%', marginBottom: '0.5%' }}
                        onClick={() => setOvulationStudyDialog(true)}
                        disabled={!['new', 'edit'].includes(currentAction)}
                      >
                        Add Details
                      </Button>
                      <Grid container spacing={2}>
                        <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                          <Table
                            containerSX={{ flex: 1, border: '1px solid rgba(0,0,0,0.27)' }}
                            columns={OVULATION_STUDY_DETAIL}
                            data={ovulationStudy.map((data,index) => ({ _id: index, ...data }))}
                            showDeleteAction={true}
                            onDeleteHandler={handleDeleteOvulationStudy}
                            disabled={!['new', 'edit'].includes(currentAction)}
                          />
                        </Grid>
                      </Grid>
                    </>
                  )}
                </Grid>
              </Grid>
            </Box>
          </FormProvider>
        </Container>
      </Paper>
      <Dialog
        open={openQueryDialog}
        onClose={() => setOpenQueryDialog(false)}
        PaperProps={{ sx: { width: '80%', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <Stack
          padding={0}
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          borderBottom="1px solid"
          borderColor="grey.300"
        >
          <Typography variant="h4" fontWeight="bold">
            Patient History Query Window
          </Typography>

          <IconButton onClick={() => setOpenQueryDialog(false)}>
            <CloseIcon color="error" fontSize="large" />
          </IconButton>
        </Stack>
        <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 0 }}>
          <MuiTextField
            sx={{
              width: '100%',
              '& .MuiOutlinedInput-root': {
                padding: '0',
                fontSize: '1.4rem'
              },
              '& .MuiOutlinedInput-input': {
                padding: '8px 1.4rem'
              },
              '& .MuiInputLabel-root': {
                fontSize: '1.2rem'
              }
            }}
            label="Search Patient"
            variant="outlined"
            value={queryInput}
            onChange={handleQueryChange}
          />
        </Stack>
        <Table
          sx={{ mt: 0.5 }}
          columns={TABLE_HEADER}
          data={patientDataObj?.data || []}
          loading={patientDataObj.loading}
          onRowClick={(row) => {
            setSelectedRecord(row);
            setOpenQueryDialog(false);
          }}
        />
      </Dialog>
      <Dialog
        PaperProps={{ sx: { width: '80%', p: 2 } }}
        open={searchPatientRegisterationDialog}
        onClose={() => setSearchPatientRegisterationDialog(false)}
        maxWidth="xl"
        scroll="body"
      >
        <Stack
          padding={0}
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          borderBottom="1px solid"
          borderColor="grey.300"
        >
          <Typography variant="h4" fontWeight="bold">
            Patient Query Window
          </Typography>
          <IconButton onClick={() => setSearchPatientRegisterationDialog(false)}>
            <CloseIcon color="error" fontSize="large" />
          </IconButton>
        </Stack>
        <Table
          sx={{ mt: 0.5 }}
          columns={PATIENT_TABLE_HEADER}
          data={patientDetailList || []}
          onRowClick={(row) => {
            searchHistoryDetails(row?.uhid);
            setValue('uhid', row.uhid);
            setValue('visit_no', row.visit_no);
            setValue('op', row.op_no);
            setValue('patient_name', `${row.first_name} ${row.last_name}`);
            setValue('patient_suffix', row.name_suffix);
            setValue('opd_type', row.opd_type?.type);
            setValue('ref_type', row.ref_by?.referral_name);
            setValue('application_no', row.app_no_date);
            setValue('doctor', row.consultant?.name);
            doctorIDRef.current = row.consultant?._id;
            setValue('department', row.department?.department);
            setValue('sponsor', row.sponsor?.name);
            sponsorIDRef.current = row.sponsor?._id;
            setValue('remarks', row.remarks);
            setValue('queue_no', row.app_no_date);
            setValue('card_no', row.chq_card_no);
            setValue('vertical', row.vertical?.verticalname);
            setValue('patient_age', calculateAge(row.dob));
            setValue('mobile', row?.address?.mobile);
            setSearchPatientRegisterationDialog(false);
          }}
        />
      </Dialog>
      <Dialog
        open={patientHistoryDialog}
        onClose={() => setPatientHistoryDialog(false)}
        PaperProps={{ sx: { p: 2, width: '60rem' } }}
        maxWidth="xl"
        scroll="body"
      >
        <IVFTreatementPatientHistory
          onClose={() => setPatientHistoryDialog(false)}
          onAdd={onAddPatientHistory}
          setPatientHistoryDialog={setPatientHistoryDialog}
        />
      </Dialog>

      <Dialog
        open={menustralHistoryDialog}
        onClose={() => setMenustralHistoryDialog(false)}
        PaperProps={{ sx: { p: 2, width: '90rem' } }}
        maxWidth="xl"
        scroll="body"
      >
        <MenustralHistory
          onClose={() => setMenustralHistoryDialog(false)}
          onAdd={(row) => setMenustralHistory((prev) => [...prev, row])}
          setMenustralHistoryDialog={setMenustralHistoryDialog}
        />
      </Dialog>
      <Dialog
        open={infertilityDialog}
        onClose={() => setInfertilityDialog(false)}
        PaperProps={{ sx: { p: 2, width: '90rem' } }}
        maxWidth="xl"
        scroll="body"
      >
        <InfertilityDetailsForm
          onClose={() => setInfertilityDialog(false)}
          onAdd={(row) => setInfertility((prev) => [...prev, row])}
          setInfertilityDialog={setInfertilityDialog}
        />
      </Dialog>
      <Dialog
        open={obstericHistoryDialog}
        onClose={() => setObstericHistoryDialog(false)}
        PaperProps={{ sx: { p: 2, width: '50rem' } }}
        maxWidth="xl"
        scroll="body"
      >
        <ObstericDetailsForm
          onClose={() => setObstericHistoryDialog(false)}
          onAdd={(row) => setObsteric((prev) => [...prev, row])}
          setObstericHistoryDialog={setObstericHistoryDialog}
        />
      </Dialog>
      <Dialog
        open={medicalHistoryDialog}
        onClose={() => setMedicalHistoryDialog(false)}
        PaperProps={{ sx: { p: 2, width: '100rem' } }}
        maxWidth="xl"
        scroll="body"
      >
        <MedicalHistory
          onClose={() => setMedicalHistoryDialog(false)}
          onAdd={(row) => setMedicalHistory((prev) => [...prev, row])}
          setMedicalHistoryDialog={setMedicalHistoryDialog}
        />
      </Dialog>

      <Dialog
        open={infertilityTreatmentDialog}
        onClose={() => setInfertilityTreatmentDialog(false)}
        PaperProps={{ sx: { p: 2, width: '60rem' } }}
        maxWidth="xl"
        scroll="body"
      >
        <InfertilityTreatement
          onClose={() => setInfertilityTreatmentDialog(false)}
          onAdd={(row) => setInfertilityTreatment((prev) => [...prev, row])}
          setInfertilityTreatmentDialog={setInfertilityTreatmentDialog}
        />
      </Dialog>

      <Dialog
        open={familyHistoryDialogueOpen}
        onClose={() => setFamilyHistoryDialogueOpen(false)}
        PaperProps={{ sx: { p: 2, width: '45rem' } }}
        maxWidth="xl"
        scroll="body"
      >
        <FamilyHistoryDetailsForm
          onClose={() => setFamilyHistoryDialogueOpen(false)}
          onAdd={(row) => setFamilyHistory((prev) => [...prev, row])}
          setFamilyHistoryDialogueOpen={setFamilyHistoryDialogueOpen}
        />
      </Dialog>

      <Dialog
        open={personalHistoryDialog}
        onClose={() => setPersonalHistoryDialog(false)}
        PaperProps={{ sx: { p: 2, width: '80rem' } }}
        maxWidth="xl"
        scroll="body"
      >
        <PersonalHistoryDetailsForm
          onClose={() => setPersonalHistoryDialog(false)}
          onAdd={(row) => setPerosnalHistory((prev) => [...prev, row])}
          setPersonalHistoryDialog={setPersonalHistoryDialog}
        />
      </Dialog>

      <Dialog
        open={surgicalHistoryDialog}
        onClose={() => setSurgicalHistoryDialog(false)}
        PaperProps={{ sx: { p: 2, width: '120rem' } }}
        maxWidth="xl"
        scroll="body"
      >
        <SurgicalHistoryDetailsForm
          onClose={() => setSurgicalHistoryDialog(false)}
          onAdd={(row) => setSurgicalHistory((prev) => [...prev, row])}
          setSurgicalHistoryDialog={setSurgicalHistoryDialog}
        />
      </Dialog>


      <Dialog
        open={ovulationStudyDialog}
        onClose={() => setOvulationStudyDialog(false)}
        PaperProps={{ sx: { p: 2, width: '120rem' } }}
        maxWidth="xl"
        scroll="body"
      >
        <OvulationHistoryDetailsForm
          onClose={() => setOvulationStudyDialog(false)}
          onAdd={(row) => setOvulationStudy((prev) => [...prev, row])}
          setOvulationStudyDialog={setOvulationStudyDialog}
        />
      </Dialog>
    </>
  );
};
